import React from "react";

import ReactDOM from "react-dom";

import {
    useState,
    useEffect
} from "react";

import Spinner from "../spinners/DataSpinner";

import axios from "axios";

import swal from "sweetalert";

import {
    Link,
    useNavigate
} from "react-router-dom";

const Checkout = () => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [cart, setCart] = useState([]);
    let grandTotal = 0;

    const [error, setError] = useState([]);

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        payment_mode: '',
    });

    const handeInput = (e) => {
        e.persist();
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }

    const closeModal = () => {
        // console.log("Hello")
        // var myModal = new window.bootstrap.Modal(document.getElementById('payOnlineModal'));
        // myModal.hide();
    }

    let orderinfo_data = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        phone: formData.phone,
        email: formData.email,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zipcode: formData.zipcode,
        payment_mode: "Paid By Paypal",
        payment_id: "",
    };

    // PayPal
    const PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM });

    // const createOrder = (data) => {
    //     // Order is created on the server and the order id is returned
    //     return fetch("/my-server/create-paypal-order", {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //         // use the "body" param to optionally pass additional order information
    //         // like product skus and quantities
    //         body: JSON.stringify({
    //             cart: [
    //                 {
    //                     sku: "YOUR_PRODUCT_STOCK_KEEPING_UNIT",
    //                     quantity: "YOUR_PRODUCT_QUANTITY",
    //                 },
    //             ],
    //         }),
    //     })
    //         .then((response) => response.json())
    //         .then((order) => order.id);
    // };

    // const onApprove = (data) => {
    //     // Order is captured on the server and the response is returned to the browser
    //     return fetch("/my-server/capture-paypal-order", {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify({
    //             orderID: data.orderID
    //         })
    //     })
    //         .then((response) => response.json());
    // };

    const createOrder = (data, actions) => {
        return actions.order.create({
            purchase_units: [
                {
                    amount: {
                        value: grandTotal
                    },
                },
            ],
        });
    };

    const onApprove = (data, actions) => {
        return actions.order.capture().then(function (details) {
            console.log(details);
            orderinfo_data.payment_id = details.id;
            axios.post(`/api/place-order`)
                .then(res => {
                    if (res.data.status === 200) {
                        swal("Success", res.data.message, "success");
                        setError([]);
                        navigate('/thank-you');
                    } else if (res.data.status === 422) {
                        swal("Warning", "All fields mondatory", "warning");
                        setError(res.data.errors);
                    } else if (res.data.status === 401) {
                        swal("Warning", res.data.message, "warning");
                    }
                });
        });
    }


    const handleFormSubmit = (e, payment_mode) => {
        e.preventDefault();

        let data = {
            first_name: formData.first_name,
            last_name: formData.last_name,
            phone: formData.phone,
            email: formData.email,
            address: formData.address,
            city: formData.city,
            state: formData.state,
            zipcode: formData.zipcode,
            payment_mode: formData.payment_mode,
            payment_id: "",
        };

        switch (payment_mode) {
            case "code":
                axios.post(`/api/place-order`, data)
                    .then(res => {
                        if (res.data.status === 200) {
                            swal("Success", res.data.message, "success");
                            setError([]);
                            navigate('/thank-you');
                        } else if (res.data.status === 422) {
                            swal("Warning", "All fields mondatory", "warning");
                            setError(res.data.errors);
                        } else if (res.data.status === 401) {
                            swal("Warning", res.data.message, "warning");
                        }
                    });
                break;
            case "razorpay":
                axios.post(`/api/validate-order`, data)
                    .then(res => {
                        if (res.data.status === 200) {
                            setError([]);
                            var options = {
                                "key": "YOUR_KEY_ID",
                                // "amount": (grandTotal * 100),
                                "amount": (1 * 100),
                                "name": "Ecommerce App",
                                "description": "Thank you for purchasing with Ecommerce App",
                                "image": "https://example.com/your_logo",
                                "handler": function (response) {
                                    data.payment_id = response.razorpay_payment_id;
                                    axios.post(`/api/place-order`, data)
                                        .then(place_res => {
                                            if (place_res.data.status === 200) {
                                                swal("Success", place_res.data.message, "success");
                                                navigate('/thank-you');
                                            }
                                        });
                                },
                                "prefill": {
                                    "name": data.first_name + ' ' + data.last_name,
                                    "email": data.email,
                                    "contact": data.phone
                                },
                                "theme": {
                                    "color": "#3399cc"
                                }
                            };
                            var rzp1 = new window.Razorpay(options);

                            rzp1.open();

                        } else if (res.data.status === 422) {
                            swal("Warning", "All fields mondatory", "warning");
                            setError(res.data.errors);
                        } else if (res.data.status === 401) {
                            swal("Warning", res.data.message, "warning");
                        }
                    });
                break;
            case "paypal":
                axios.post(`/api/validate-order`, data)
                    .then(res => {
                        if (res.data.status === 200) {
                            setError([]);
                            var myModal = new window.bootstrap.Modal(document.getElementById('payOnlineModal'));
                            myModal.show();
                        } else if (res.data.status === 422) {
                            swal("Warning", "All fields mondatory", "warning");
                            setError(res.data.errors);
                        } else if (res.data.status === 401) {
                            swal("Warning", res.data.message, "warning");
                        }
                    });
                break;
        }
    }

    useEffect(() => {

        let isMounted = true;

        axios.get(`api/cart`)
            .then(res => {
                if (isMounted) {
                    if (res.data.status === 200) {
                        setCart(res.data.cart);
                        setLoading(false);
                    } else if (res.data.status == 401) {
                        swal('Warning', res.data.message, 'error');
                        navigate("/");
                    }
                }
            });

        return () => {
            isMounted = false;
        }
    }, [navigate]);

    if (loading) {
        return <Spinner />
    } else {
        var checkoutHtml = '';
        if (cart.length) {
            checkoutHtml =
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                    <div className="col-lg-8">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="row border rounded bg-white pt-4">
                                    <div className="col-lg-6 form-group mb-3">
                                        <label>First Name: </label>
                                        <input type="text" onChange={handeInput} value={formData.first_name} name="first_name" className="form-control" />
                                        <small className="text-danger">{error.first_name}</small>
                                    </div>
                                    <div className="col-lg-6 form-group mb-3">
                                        <label>Last Name: </label>
                                        <input type="text" onChange={handeInput} value={formData.last_name} name="last_name" className="form-control" />
                                        <small className="text-danger">{error.last_name}</small>
                                    </div>
                                    <div className="col-lg-6 form-group mb-3">
                                        <label>Phone Number: </label>
                                        <input type="text" onChange={handeInput} value={formData.phone} name="phone" className="form-control" />
                                        <small className="text-danger">{error.phone}</small>
                                    </div>
                                    <div className="col-lg-6 form-group mb-3">
                                        <label>Email Address: </label>
                                        <input type="email" onChange={handeInput} value={formData.email} name="email" className="form-control" />
                                        <small className="text-danger">{error.email}</small>
                                    </div>
                                    <div className="col-lg-12 form-group mb-3">
                                        <label>Full Address: </label>
                                        <textarea className="form-control" rows="4" cols="3" onChange={handeInput} value={formData.address} name="address"></textarea>
                                        <small className="text-danger">{error.address}</small>
                                    </div>

                                    <div className="col-lg-4 form-group mb-3">
                                        <label>City: </label>
                                        <input type="text" onChange={handeInput} value={formData.city} name="city" className="form-control" />
                                        <small className="text-danger">{error.city}</small>
                                    </div>

                                    <div className="col-lg-4 form-group mb-3">
                                        <label>State: </label>
                                        <input type="text" onChange={handeInput} value={formData.state} name="state" className="form-control" />
                                        <small className="text-danger">{error.state}</small>
                                    </div>

                                    <div className="col-lg-4 form-group mb-3">
                                        <label>Zip Code: </label>
                                        <input type="text" onChange={handeInput} value={formData.zipcode} name="zipcode" className="form-control" />
                                        <small className="text-danger">{error.zipcode}</small>
                                    </div>

                                    <div className="col-lg-12 form-group mb-3">
                                        <button type="submit" className="btn btn-primary mr-2" onClick={(e) => handleFormSubmit(e, 'code')}>Place Order</button>
                                        <button type="submit" className="btn btn-secondary mr-2" onClick={(e) => handleFormSubmit(e, 'razorpay')}>Pay By Razorpay</button>
                                        <button type="submit" className="btn btn-danger" onClick={(e) => handleFormSubmit(e, 'paypal')}>Pay By paypal</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="border rounded bg-white pt-4">
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="text-center">Product</th>
                                            <th className="text-center">Price</th>
                                            <th className="text-center">Qty</th>
                                            <th className="text-center">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cart.map((item) => {
                                            grandTotal += item.product_qty * item.product.sale_price;
                                            return (
                                                <tr key={item.id}>
                                                    <td className="text-center align-middle">{item.product.name}</td>
                                                    <td className="text-center align-middle">{item.product.sale_price}</td>
                                                    <td className="text-center align-middle">{item.product_qty}</td>
                                                    <td className="text-center align-middle">{item.product_qty * item.product.sale_price}$</td>
                                                </tr>
                                            )
                                        })
                                        }
                                        <tr>
                                            <td colSpan="3" className="text-center align-middle">Grand Total</td>
                                            <td className="text-center align-middle">{grandTotal}$</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
        } else {
            checkoutHtml =
                <div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                        <div className="col-lg-12">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th className="text-center">Product</th>
                                        <th className="text-center">Price</th>
                                        <th className="text-center">Qty</th>
                                        <th className="text-center">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan="4" className="text-center"> The cart is empty</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
        }
    }

    return (
        <div>
            <div className="modal" id="payOnlineModal">
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Online Payment Mode</h4>
                            <button type="button" className="btn-close" onClick={closeModal}></button>
                        </div>

                        <div className="modal-body">
                            <hr />
                            {/* <PayPalButton
                                createOrder={(data) => createOrder(data, actions)}
                                onApprove={(data) => onApprove(data, actions)}
                            /> */}
                        </div>

                    </div>
                </div>
            </div>
            <div className="album py-5 bg-light">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Checkout</li>
                        </ol>
                    </nav>
                    {checkoutHtml}
                </div>
            </div>
        </div>
    );
}

export default Checkout;